var map = {
	"./database.js": 430,
	"./demo.js": 200,
	"./pam.js": 431,
	"./standalone.js": 432
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 512;


//////////////////
// WEBPACK FOOTER
// ./javascript/core/auth ^\.\/.*\.js$
// module id = 512
// module chunks = 0